function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import { gsap, Power4 } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { breakpoint } from '../../../vendorjs/breakpoint-helper.vendor';
export var headerBehavior = function headerBehavior() {
  Alpine.data('headerBehavior', function () {
    return {
      numbersOpen: false,
      stickyHeaderScrollTrigger: false,
      $header: false,
      $headerMenu: false,
      $headerTop: false,
      headerOffset: {
        top: 0,
        bottom: 0,
        height: 0
      },
      headerTriggerOffset: 0,
      adminToolbarHeight: 0,
      init: function init() {
        this.refresh();
      },
      refresh: function refresh() {
        var $element = this.$el;
        this.$header = $element;
        this.$headerMenu = $element.querySelector('.o-header__menu');
        this.$headerTop = $element.querySelector('.o-header__top');
        this.$subnav = document.querySelector('.m-sub-navigation');
        this.numbersOpen = breakpoint.isDesktop;
        this.headerOffset = this.getElementDimensions($element);
        this.calculateOffset(); // @todo: Temp fix so that sticky header doesn't work on touch devices. Refactor fix issue with ScrollTrigger.

        if (!breakpoint.isTouch) {
          this.stickyHeader();
        }

        this.getModal();
      },
      stickyHeader: function stickyHeader() {
        if (this.stickyHeaderScrollTrigger) {
          this.stickyHeaderScrollTrigger.kill(true);
        }

        var $this = this;
        var $header = this.$header,
            $subnav = this.$subnav;
        this.stickyHeaderScrollTrigger = ScrollTrigger.create({
          trigger: $header,
          endTrigger: $subnav ? '.m-sub-navigation' : $header,
          pin: true,
          pinSpacing: false,
          start: "top top+=".concat($this.headerTriggerOffset),
          end: $subnav ? "top top+=".concat($this.headerTriggerOffset + $this.headerOffset.height - 1) : 'max',
          invalidateOnRefresh: true,
          // onReady: $this.slimHeader(), // WIP.
          markers: false // Useful for debugging.

        });
        this.stickyHeaderScrollTrigger.refresh(true, true);
      },
      slimHeader: function slimHeader() {
        if (this.slimHeaderScrollTrigger) {
          this.slimHeaderScrollTrigger.kill(true);
        }

        var $this = this;
        var $header = this.$header,
            $headerMenu = this.$headerMenu,
            $headerTop = this.$headerTop;
        var $headerTopLeft = $header.querySelector('.o-header__top-left');
        var $headerDesktopMenuButton = $header.querySelector('.o-header__desktop-menu-button');
        var headerScrollTrigger = {
          trigger: $header,
          start: "top top",
          end: "bottom top+=".concat($this.headerOffset.height / 4),
          delay: 0,
          scrub: true,
          markers: false // Useful for debugging.

        };
        this.menuAnimation = gsap.timeline({
          delay: 0,
          paused: true
        }).to($headerMenu, {
          ease: Power4.easeInOut,
          duration: 0.15,
          opacity: 0,
          height: 0,
          delay: 0
        }, 0).progress(0);
        this.headerAnimation = gsap.timeline({
          delay: 0.1,
          scrollTrigger: headerScrollTrigger
        }).to($headerTop, {
          ease: Power4.easeInOut,
          duration: 3,
          paddingTop: '0.5rem',
          paddingBottom: '0.5rem',
          delay: 0
        }, 0).to($headerTopLeft, {
          ease: Power4.easeInOut,
          duration: 2,
          width: '10%',
          delay: 0
        }, 0).to($headerMenu, {
          ease: Power4.easeInOut,
          duration: 2,
          opacity: 0,
          height: 0,
          delay: 1.5
        }, 1).fromTo($headerDesktopMenuButton, {
          ease: Power4.easeInOut,
          opacity: 0,
          height: 0,
          y: '1rem',
          display: 'none'
        }, {
          duration: 1,
          delay: 1.5,
          y: 0,
          opacity: 1,
          display: 'block'
        }, 2).progress(0);
      },
      getElementDimensions: function getElementDimensions(element) {
        // Get the DOM Node if you pass in a string
        var $element = typeof element === 'string' ? document.querySelector(element) : element;

        var _$element$getBounding = $element.getBoundingClientRect(),
            top = _$element$getBounding.top,
            right = _$element$getBounding.right,
            bottom = _$element$getBounding.bottom,
            left = _$element$getBounding.left,
            width = _$element$getBounding.width,
            height = _$element$getBounding.height,
            x = _$element$getBounding.x,
            y = _$element$getBounding.y;

        var dimensions = {
          top: top,
          right: right,
          bottom: bottom,
          left: left,
          width: width,
          height: height,
          x: x,
          y: y
        };
        var styles = window.getComputedStyle($element);
        var marginTop = parseFloat(styles.marginTop);
        var marginBottom = parseFloat(styles.marginBottom);
        var marginY = marginTop + marginBottom;
        var outerHeight = Math.ceil(height + marginY);
        return _objectSpread(_objectSpread({}, dimensions), {}, {
          outerHeight: outerHeight,
          marginTop: marginTop,
          marginBottom: marginBottom,
          marginY: marginY
        });
      },
      calculateOffset: function calculateOffset() {
        this.headerTriggerOffset = 0;
        var adminToolbar = document.querySelector('#toolbar-bar');

        if (adminToolbar) {
          var adminToolbarDimensions = this.getElementDimensions(adminToolbar);
          this.adminToolbarHeight = adminToolbarDimensions.outerHeight;
          this.headerTriggerOffset += this.adminToolbarHeight;
        }
      },
      getModal: function getModal() {
        var modal = document.querySelector('div.a-form-modal_open');

        if (modal) {
          var header = document.querySelector('header');
          header.parentElement.classList.add('modal-open');
        }
      },
      header: {
        // eslint-disable-next-line func-names
        '@resize.window.stop.debounce.200ms': function resizeWindowStopDebounce200ms() {
          if (breakpoint.isDesktop) {
            this.refresh();
          }
        },
        // eslint-disable-next-line func-names
        '@load.window': function loadWindow() {
          this.refresh();
        }
      },
      headerMenu: {}
    };
  });
};